import { strings } from 'Constants/Categorization/Strings';
import { TagTypes } from 'Constants/Categorization/Tags';

export const getTagFilters = periodTags => [
  { id: 0, name: strings.anyTag },
  ...periodTags
    .filter(p => p.type === TagTypes.Text || p.type === TagTypes.TextWholeValue)
    .map(p => ({ id: p.id, name: p.name })),
];
